import { Inject, Injectable } from '@angular/core';
import { ScrudgRevisionService } from '../base/scrudg-revision/scrudg-revision.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReadResult } from '../../models/net/result/crud/read-result';
import { HttpCrudFactory } from '../../utilities/http-crud-factory';

@Injectable({
    providedIn: 'root'
})

export class PersonService extends ScrudgRevisionService {

    public constructor(public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "person");
    }

    public readByUserUIDSessionId(userUID: string, sessionId: string): Observable<ReadResult | null> {

        const result = HttpCrudFactory.get(this.http, this._apiBaseUrl, "person/envelope/read/" + userUID + "/" + sessionId);

        return result;
    }
}
